import React from "react";

import {Container} from "./styles";
import { ReactComponent as InfoIcon } from '../../assets/icons/info.svg'


interface TopNotificationProps {
    type: 'warning' | 'info';
    message: string
}

export const TopNotification = ({type, message}:TopNotificationProps) => {
    return <Container type={type}>
        <InfoIcon height={27} width={27}/>
        <p>{message}</p>
    </Container>
}
